// NOTE(IL, 2024-04-09): some errors like CIRCULAR_GRAPH, MISSING_INSTRUMENT, and NO_TASK_PROPERTIES
// should never happen with the Redux state as it is, this is just an escape valve for if
// something unexpected happens to the state.
export const CIRCULAR_GRAPH = 'CIRCULAR_GRAPH';
export const MISSING_INSTRUMENT = 'MISSING_INSTRUMENT';
export const MISSING_TIME_ESTIMATE = 'MISSING_TIME_ESTIMATE';
export const NO_LABWARE_FOR_TASK = 'NO_LABWARE_FOR_TASK';
export const NO_TASK_PROPERTIES = 'NO_TASK_PROPERTIES';
export const MINIMUM_GRAPH_REQUIREMENTS = 'MINIMUM_GRAPH_REQUIREMENTS';
export const INVALID_TASK_DEPENDENCIES = 'INVALID_TASK_DEPENDENCIES';
export const INVALID_TASK_FIELD_VALUES = 'INVALID_TASK_FIELD_VALUES';
export const TASK_SLOT_FILLING_RULE_INVALID_SLOT_STRING =
  'TASK_SLOT_FILLING_RULE_INVALID_SLOT_STRING';

export type TaskError =
  | typeof CIRCULAR_GRAPH
  | typeof MISSING_INSTRUMENT
  | typeof MISSING_TIME_ESTIMATE
  | typeof INVALID_TASK_FIELD_VALUES
  | typeof NO_LABWARE_FOR_TASK
  | typeof NO_TASK_PROPERTIES
  | typeof MINIMUM_GRAPH_REQUIREMENTS
  | typeof INVALID_TASK_DEPENDENCIES
  | typeof TASK_SLOT_FILLING_RULE_INVALID_SLOT_STRING;
